import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {InvoiceDocument} from "../interface/invoice-document";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class InvoiceDocumentService {
  public readonly invoiceDocumentListSubject: ReplaySubject<CountedAndPaginated<InvoiceDocument>> = new ReplaySubject<CountedAndPaginated<InvoiceDocument>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: object, invoiceDocumentId?: number): Observable<any> {
    if (invoiceDocumentId) {
      return this.httpClient.put(`/rest/crm/invoice-document/${invoiceDocumentId}`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.httpClient.post('/rest/crm/invoice-document', formData)
        .pipe(
          take(1)
        );
    }
  }

  public get(invoiceDocumentId: string): Observable<InvoiceDocument> {
    return this.httpClient.get(`/rest/crm/invoice-document/${invoiceDocumentId}`)
      .pipe(first()) as Observable<InvoiceDocument>;
  }

  public loadList(
    page: number,
    pageSize: number,
    filters: object,
    sort?: {
      sortBy?: string,
      sortOrder?: string,
    },
    subject?: Subject<CountedAndPaginated<InvoiceDocument>>): void {
    this.httpClient.get(`/rest/crm/invoice-document?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<InvoiceDocument>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.invoiceDocumentListSubject.next(result);
        }
      });
  }

  public downloadPdf(invoiceDocumentId: string): void {
    this.document.location.href = `/rest/crm/invoice-document/${invoiceDocumentId}/downloadFile`;
  }
  public downloadDeductionPdf(invoiceDocumentDeductionId: string): void {
    this.document.location.href = `/rest/crm/invoice-document-deduction/${invoiceDocumentDeductionId}/downloadFile`;
  }

  public downloadReport(filters: object,  sort?: { sortBy?: string, sortOrder?: string}): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/invoice-document/method/report?&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public delete(invoiceId: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/invoice-document/${invoiceId}/note`)
      .pipe(first());
  }
}
